import { App } from '@capacitor/app';
import api from './api/client';
import { queryClient } from '../lib/queryClient';
import { getAppLockService } from './AppLockService';

const RECOVERY_PATH = '/account/app-lock-recovery/complete';
const CODE_PATTERN = /^[a-zA-Z0-9_-]+$/;

async function handleRecoveryDeepLink(code: string): Promise<void> {
  try {
    await api.post('/users/app-lock-recovery/verify', { token: code });
    await getAppLockService().clearAppLockCredentials();
    queryClient.invalidateQueries({ queryKey: ['mobile-privacy'] });
    window.dispatchEvent(new CustomEvent('helm:recovery-success'));
  } catch {
    window.dispatchEvent(new CustomEvent('helm:recovery-error'));
  }
}

export function registerDeepLinkHandler(): void {
  App.addListener('appUrlOpen', async ({ url }) => {
    let parsed: URL;
    try {
      parsed = new URL(url);
    } catch {
      return;
    }

    if (
      parsed.hostname === 'helmapp.co' &&
      parsed.pathname === RECOVERY_PATH
    ) {
      const code = parsed.searchParams.get('code');
      if (!code || !CODE_PATTERN.test(code)) return;
      await handleRecoveryDeepLink(code);
    }
  });
}
